import * as React from "react";
export default function ContactPageTitle() {
  return <section id="contact-page-title" className="bg-background ![padding:30px_0px_20px_0px]">
      <div className="page-container flex flex-col items-center justify-center text-center">
        <h1 className="font-bold tracking-tight text-foreground mb-6 uppercase !font-sans !text-[40px]">
          Contact Us
        </h1>
        <p className="font-sans text-lg text-muted-foreground max-w-2xl mx-auto !font-bold md:text-xl">
          We're here to help and answer any question you might have. We look forward to hearing from you.
        </p>
      </div>
    </section>;
}